import {Component, Input, OnInit} from '@angular/core';
import {RozvrhovaAkcia} from '../model/RozvrhovaAkcia';

@Component({
    selector: 'app-rozvrhova-akcia',
    templateUrl: './rozvrhova-akcia.component.html',
    styleUrls: ['./rozvrhova-akcia.component.css'],
    standalone: false
})
export class RozvrhovaAkciaComponent implements OnInit {

  @Input() akcia: RozvrhovaAkcia;
  @Input() disabled: boolean;

  constructor() {
  }

  ngOnInit(): void {
  }

  checkboxClick($event) {
    $event.stopPropagation();
  }
}
